/**
 * 將文案模板中的 {name} 或 {0} 佔位符替換為實際值。
 */
export function formatMessage(template, values = {}) {
  if (typeof template !== 'string' || !template) {
    return template || '';
  }
  return template.replace(/\{(\w+)\}/g, (match, name) => {
    if (Object.prototype.hasOwnProperty.call(values, name)) {
      const value = values[name];
      return value == null ? '' : String(value);
    }
    return match;
  });
}
